/**
 * Logs detallados del snapshot de catálogo (batches SQLite, coalescing, etc.).
 * Por defecto la consola queda limpia; para depurar: EXPO_PUBLIC_CATALOG_SYNC_VERBOSE=1
 */
export function isCatalogSnapshotVerbose(): boolean {
  try {
    return typeof process !== 'undefined' && process.env?.EXPO_PUBLIC_CATALOG_SYNC_VERBOSE === '1';
  } catch {
    return false;
  }
}

export function catalogSnapshotVerboseLog(...args: unknown[]): void {
  if (!__DEV__ || !isCatalogSnapshotVerbose()) return;
  console.log(...args);
}

export function catalogSnapshotVerboseWarn(...args: unknown[]): void {
  if (!__DEV__ || !isCatalogSnapshotVerbose()) return;
  console.warn(...args);
}
